import React from 'react';
import { Skeleton, TableCell, TableRow } from '@mui/material';

export const TableLoading = () => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell component="th" scope="row">
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell>
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell align="right">
        <Skeleton width={'30%'} height={20} />
      </TableCell>
      <TableCell align="right">
        <Skeleton width={'30%'} height={20} />
      </TableCell>
      <TableCell align="right">
        <Skeleton width={'30%'} height={20} />
      </TableCell>
      <TableCell align="right">
        <Skeleton width={'30%'} height={20} />
      </TableCell>
      <TableCell align="right">
        <Skeleton width={'30%'} height={20} />
      </TableCell>
      <TableCell align="right">
        <Skeleton width={'30%'} height={20} />
      </TableCell>
    </TableRow>
  );
};
